import { styled } from '@mui/material/styles';

export const TopbarLogoWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 1;
  min-width: 0;

  img {
    display: block;
    width: auto;
    max-width: 100%;
    height: 2rem;
    object-fit: contain;
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    img {
      height: 3.2rem;
    }
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    img {
      height: 3.2rem;
    }
  }
`;
